<template>
    <form class="add-admin-form">
        <section>
            <label>Super admin</label>
            <input type="checkbox" v-model="is_super_admin" disabled>
        </section>

        <section>
            <label>Prénom</label>
            <input type="text" v-model="firstname">
        </section>

        <section>
            <label>Nom</label>
            <input type="text" v-model="lastname">
        </section>

        <section>
            <label>Adresse email</label>
            <input type="email" v-model="email">
        </section>

        <section>
            <label>Actif</label>
            <select v-model="is_active">
                <option :value="true">OUI</option>
                <option :value="false">NON</option>
            </select>
        </section>

        <p>{{ errMsg }}</p>

        <div class="save-btn" @click="saveForm">Enregistrer</div>
    </form>
</template>

<script>
import axios from 'axios';

export default {
    props: ['adminData'],
    data() {
        return {
            firstname: "",
            lastname: "",
            email: "",
            is_active: true,
            is_super_admin: false,
            errMsg: "",
        }
    },
    watch: {
        errMsg() {
            this.$store.commit('changeErrorMsg', this.errMsg);
        }
    },
    computed: {
        isCreation() {
            return !this.adminData;
        },
        adminPayload() {
            return {
                _id: this.adminData?._id,
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                is_active: this.is_active,
                password: this.password,
            }
        },
    },
    methods: {
        checkForm() {
            if (this.firstname == '') {
                this.errMsg = "Veuillez renseigner un prénom.";
                return false;
            } else if (this.lastname == '') {
                this.errMsg = "Veuillez renseigner un nom de famille.";
                return false;
            } else if (this.email == '') {
                this.errMsg = "Veuillez renseigner une adresse email.";
                return false;
            } else {
                return true;
            }
        },
        async createAdmin() {
            try {
                const is_valid = this.checkForm();
                if (!is_valid) return;

                await axios.post(this.$store.getters.get_api_url + 'auth/create-admin/', this.adminPayload);

                this.$emit('valueSaved');
            } catch (err) {
                this.$store.commit('changeErrorMsg', err.response?.data.message || "Erreur lors de la création");
            }
        },
        async updateAdmin() {
            try {
                const is_valid = this.checkForm();
                if (!is_valid) return;

                await axios.put(this.$store.getters.get_api_url + 'auth/modify/', this.adminPayload);

                this.$emit('valueSaved');
            } catch (err) {
                this.$store.commit('changeErrorMsg', err.response?.data.message || "Erreur lors de la mise à jour");
            }

        },
        saveForm() {
            if (this.isCreation) {
                this.createAdmin();
            } else {
                this.updateAdmin();
            }
        }
    },
    mounted() {
        if (this.adminData) {
            this.firstname = this.adminData.firstname;
            this.lastname = this.adminData.lastname;
            this.email = this.adminData.email;
            this.is_active = this.adminData.is_active;
            this.is_super_admin = this.adminData.is_super_admin;
        }
    }
}
</script>

<style scoped>
.add-admin-form {
    padding: 10px 25px;
    display: flex;
    flex-direction: column;
    font-size: 25px;
}

.add-admin-form section {
    display: flex;
    flex-direction: column;
    margin: 10px 0;
}

.add-admin-form label,
.add-admin-form input,
.add-admin-form select {
    font-size: 12px;
}

.add-admin-form input,
.add-admin-form select {
    border-radius: 5px;
    padding: 5px;
    border: 1px solid lightgrey;
}

.authorization-table {
    width: 100%;
    margin: 10px auto;
    table-layout: fixed;
    border-collapse: collapse;
}

.authorization-table th {
    background-color: #0A1C6B;
    color: white;
}

.authorization-table th,
.authorization-table td {
    font-size: 11px;
    text-align: left;
    position: relative;
    padding: 10px;
    border: 1px solid lightgrey;
}

.authorization-table td select {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    border: none;
}

.save-btn {
    cursor: pointer;
    display: inline-block;
    margin: 20px auto 20px auto;
    padding: 10px;
    border-radius: 10px;
    font-size: 12px;
    background-color: #0A1C6B;
    color: white;
}

.save-btn:hover {
    background-color: #0032AA;
}
</style>